import { render, staticRenderFns } from "./page-locked.vue?vue&type=template&id=f2119b16&scoped=true&"
import script from "./page-locked.vue?vue&type=script&lang=js&"
export * from "./page-locked.vue?vue&type=script&lang=js&"
import style0 from "./page-locked.vue?vue&type=style&index=0&id=f2119b16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2119b16",
  null
  
)

export default component.exports